import { render } from "./QuestionList.vue?vue&type=template&id=b879e6a8"
import script from "./QuestionList.vue?vue&type=script&lang=js"
export * from "./QuestionList.vue?vue&type=script&lang=js"

import "./QuestionList.vue?vue&type=style&index=0&id=b879e6a8&lang=css"

import exportComponent from "/Users/rafalstepien/Documents/Programming/blovi/imdm/IMDM/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__